const RecorderViewActions = {
  FETCH_RECORDER_VIEW: 'FETCH_RECORDER_VIEW',
  FETCH_RECORDER_VIEW_SUCCESS: 'FETCH_RECORDER_VIEW_SUCCESS',
  FETCH_RECORDER_VIEW_UPDATE: 'FETCH_RECORDER_VIEW_UPDATE',
  FETCH_RECORDER_VIEW_UPDATE_SUCCESS: 'FETCH_RECORDER_VIEW_UPDATE_SUCCESS',
  FETCH_RECORDER_VIEW_ERROR: 'FETCH_RECORDER_VIEW_ERROR',
  FETCH_RECORDER_VIEW_CLEAN_STATE: 'FETCH_RECORDER_VIEW_CLEAN_STATE',
  FETCH_RECORDER_VIEW_DATA_CLEAR: 'FETCH_RECORDER_VIEW_DATA_CLEAR',
  SET_RECORDER_VIEW_DATA: 'SET_RECORDER_VIEW_DATA',
};

const fetchRecorderView = (data) => ({
  type: RecorderViewActions.FETCH_RECORDER_VIEW,
  payload: data,
});
const fetchRecorderViewSuccess = (data) => ({
  type: RecorderViewActions.FETCH_RECORDER_VIEW_SUCCESS,
  payload: data,
});
const fetchRecorderViewUpdate = (data) => ({
  type: RecorderViewActions.FETCH_RECORDER_VIEW_UPDATE,
  payload: data,
});
const fetchRecorderViewUpdateSuccess = (data) => ({
  type: RecorderViewActions.FETCH_RECORDER_VIEW_UPDATE_SUCCESS,
  payload: data,
});
const fetchRecorderViewError = ({ message }) => ({
  type: RecorderViewActions.FETCH_RECORDER_VIEW_ERROR,
  payload: message,
});
const fetchRecorderViewCleanState = () => ({
  type: RecorderViewActions.FETCH_RECORDER_VIEW_CLEAN_STATE,
});
const fetchRecorderViewDataClear = () => ({
  type: RecorderViewActions.FETCH_RECORDER_VIEW_DATA_CLEAR,
});
const setRecorderViewData = (data) => ({
  type: RecorderViewActions.SET_RECORDER_VIEW_DATA,
  payload: data,
});

export {
  RecorderViewActions,
  fetchRecorderView,
  fetchRecorderViewSuccess,
  fetchRecorderViewUpdate,
  fetchRecorderViewUpdateSuccess,
  fetchRecorderViewError,
  fetchRecorderViewCleanState,
  fetchRecorderViewDataClear,
  setRecorderViewData,
};
